import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import { MASTER_BREADCRUMBS, MASTER_NAV } from './nav';

/**
 * Casco do painel Master (`superadminvisual` §3 e §6).
 *
 * Tudo fica dentro de `.master-shell`, que é onde moram os tokens roxos. Sem
 * esse invólucro os tokens teriam de ir para `:root` — e como Master e painel do
 * cliente são a MESMA SPA, isso repintaria o cliente inteiro.
 */
export function MasterLayout() {
  const { usuario, sair } = useAuth();
  const { pathname } = useLocation();

  const breadcrumb = MASTER_BREADCRUMBS[pathname] ?? 'Dashboard';
  const inicial = (usuario?.name ?? '?').charAt(0).toUpperCase();

  return (
    <div className="master-shell">
      <div className="app-shell">
        <aside className="master-sidebar">
          <div className="master-logo">
            <div className="logo-text">
              Matéria
              <span className="logo-bold">
                Prim<span className="logo-ai-yellow">Ai</span>
              </span>
              <span className="logo-badge">Master</span>
            </div>
            <div className="tagline">Painel Administrativo</div>
          </div>

          <nav className="master-nav">
            {MASTER_NAV.map((secao) => (
              <div className="nav-section" key={secao.titulo}>
                <div className="nav-section-title">{secao.titulo}</div>

                {secao.itens.map((item) =>
                  item.emBreve || !item.para ? (
                    <span className="nav-item nav-item-disabled" title="Em breve" key={item.rotulo}>
                      <i className={`ti ${item.icone}`} /> {item.rotulo}
                    </span>
                  ) : (
                    <NavLink
                      to={item.para}
                      end={item.exato}
                      key={item.rotulo}
                      className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                    >
                      <i className={`ti ${item.icone}`} /> {item.rotulo}
                    </NavLink>
                  ),
                )}
              </div>
            ))}
          </nav>

          <div className="sidebar-user">
            <div className="user-avatar">{inicial}</div>
            <div className="user-info">
              <div className="user-name">{usuario?.name}</div>
              <div className="user-role">MatériaPrimAi</div>
            </div>
            <button type="button" className="logout-btn" title="Sair" onClick={() => void sair()}>
              <i className="ti ti-logout" />
            </button>
          </div>
        </aside>

        <div className="main-area">
          <header className="master-topbar">
            <div className="topbar-breadcrumb">
              <span>Master</span>
              <i className="ti ti-chevron-right" style={{ fontSize: 10 }} />
              <span className="current">{breadcrumb}</span>
            </div>
          </header>

          <main className="page-content">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
